import { FC, useContext, useEffect, useState } from "react";
import { Box, Container, Grid, Typography, useMediaQuery } from "@material-ui/core";
import { animateScroll as scroll } from "react-scroll";

import AuthContext from "../../store/Auth/AuthContext";
import AdminHeader from "../SubComponents/AdminHeader";
import Header from "../SubComponents/Header";
import DynamicVerticalMenu from "./DynamicVerticalMenu";
import PoolDetailCard from "./PoolDetailCard";
import PoolDetailStyle from "./DetailsStyle";
import Detail from "./Detail";
import NotAuthBanner from "../SubComponents/Projects/NotAuthBanner";
import { useLocation, useParams } from "react-router";
import graphQLClient from "../../utils/authHeader";
import { GET_POOL } from "../../utils/queries/pool/getPoolQuery";
import AlertContext from "../../store/Alert/AlertContext";
import customGraphQLClient from "../../utils/customHeader";
import theme from "../../helpers/theme";
import { MdOutlineError } from "react-icons/md";
import PoolContext from "../../store/Pool/PoolContext";
import LearnContext from "../../store/Learn2/LearnContext";
import Footer from "../SubComponents/Footer";
import WhitelistExternalModal from "./WhitelistExternalPopup";
import CountryModal from "../Profile/CountryModal";
import PartnerStakeWrapper from "./PartnerStake/PartnerStakeWrapper";
import { isUUID } from "../../utils/uuid";
import errorImage from '../../assets/images/error-pool.png'

const heightToHideFrom = 400;

const PoolDetail: FC<any> = (props) => {

    const classes = PoolDetailStyle();

    const isActive = useMediaQuery(theme.breakpoints.down("md"));

    const { id: param }: any = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code');
    const { isAuth, getProfileData } = useContext<any>(AuthContext);
    const { setAlert } = useContext<any>(AlertContext);
    const { userPledges, getWhitelistedByStatus, getInvestBtnByPool, getWhitelistedCompletedByPool, addPoolToLivePools, addPoolToClosedPools, getUserListPledge } = useContext<any>(PoolContext);
    const { hasFailed, activeQuizzes, getAuthUserPoolQuiz } = useContext<any>(LearnContext);

    const [isExternalProject, toggleExternalProject] = useState<boolean>(false);
    const [openLoginModal, setOpenLoginModal] = useState<boolean>(false);
    const [poolData, setPoolData] = useState<any>(); // TODO: Add pool type
    const [titles, setTitles] = useState<{ text: string; id: string; }[]>([]);
    const [poolContent, setPoolContent] = useState<string>('');
    const [error, setError] = useState<boolean>(false);

    const [getWhitelisted, setWhitelisted] = useState<any>();
    const [whitelistedCompleted, setWhitelistedCompleted] = useState<any>();
    const [failed, setFailed] = useState<any>();
    const [investBtn, setInvestBtn] = useState<any>();
    const [openWhitelistExternalModal, toggleWhitelistExternalModal] = useState<boolean>(false);
    const [showCountryModal, setShowCountryModal] = useState<boolean>(false);
    /**
     * Scroll to top on page load
     */
    useEffect(() => {
        scroll.scrollToTop();
        window.addEventListener("scroll", listenToScroll);
        return () => window.removeEventListener("scroll", listenToScroll);
    }, []);

    useEffect(() => {
        if (code) {
            toggleExternalProject(true);
        }
    }, [])

    useEffect(() => {
        const is_uuid = isUUID(param);
        let id, slug;

        if(!is_uuid){
            slug=param
        }else {
            id=param
        }

        const variables = {
            id,
            slug,
            code: code,
        }
        if (isAuth) {
            getUserListPledge();
            getAuthUserPoolQuiz();
            graphQLClient
                .request(GET_POOL, variables)
                .then((data: any) => {
                    setPoolData(data.pool);
                    if (data.pool.status === 'closed') {
                        addPoolToClosedPools(data.pool);
                    } else {
                        if (data.pool.isExternalProject) {
                            data.pool.code = code;
                        }
                        addPoolToLivePools(data.pool);
                    }
                })
                .catch((error: any) => {
                    console.error(error.message);
                    setError(true);
                    setAlert("Unable to fetch pool data at the moment. Please try again later.", "error");
                })
        } else {
            customGraphQLClient
            .request(GET_POOL, variables)
            .then((data) => {
                setPoolData(data.pool);
                if (data.pool.status === 'closed') {
                    addPoolToClosedPools(data.pool);
                } else {
                    addPoolToLivePools(data.pool);
                }
            })
            .catch((error: any) => {
                console.error(error.message);
                setError(true);
                setAlert("Unable to fetch pool data at the moment. Please try again later.", "error");
            })
        }
    }, [isAuth])

    useEffect(() => {
        if (isAuth) {
            if (userPledges && poolData) {
                setWhitelisted(getWhitelistedByStatus(poolData.status));
                let investBtn = getInvestBtnByPool(poolData.id);
                setInvestBtn(investBtn)
                let whitelistedCompleted = getWhitelistedCompletedByPool(poolData.id);
                setWhitelistedCompleted(whitelistedCompleted)
            }
        }
    }, [isAuth, userPledges, poolData]);

    useEffect(() => {
        if (isAuth && poolData) {
            setFailed(hasFailed(poolData.id));
        }
    }, [isAuth, activeQuizzes, poolData]);
    
    const listenToScroll = () => {
        if (!isAuth) {
            const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
            if (winScroll > heightToHideFrom) {
                // setOpenLoginModal(true);
            }
        }
    }

    useEffect(() => {
        if (poolData && poolData.longDescription) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(poolData.longDescription, 'text/html');
            const h3Elements = doc.getElementsByTagName('h3');
            const tagsArray = Array.from(h3Elements).map((element: any) => {
                const id = element.textContent.replace(/\s+/g, '-');
                element.setAttribute('id', id);
                return { text: element.textContent, id };
            });
            setTitles(tagsArray);
            setPoolContent(doc.documentElement.innerHTML);
        }
    }, [poolData]);

    return (
        <>
            {
                isAuth
                ?
                    <AdminHeader />
                :
                    <Header  authPage redirect={location.pathname + location.search} />
            }

            {
                /**
                 * AuthBanner
                 */
                !openLoginModal && !isAuth && <NotAuthBanner redirect={location.pathname + location.search} />
            }
            {
                <Container
                    maxWidth="lg"
                    className={classes.container}
                >
                    {
                        (error) 
                            ?   
                                <Grid
                                    container
                                    direction="row"
                                    spacing={4}
                                    className={classes.root}
                                    style={{
                                        height: "max-content",
                                        overflow: "hidden",
                                    }}
                                    lg={12}
                                >
                                    <Grid
                                        item
                                        lg={2}
                                        md={12}
                                        xs={12}
                                        sm={12}
                                    >
                                        <DynamicVerticalMenu titles={[]} />
                                    </Grid>
                                    <Grid 
                                        item
                                        lg={10}
                                        md={12}
                                        xs={12}
                                        sm={12}
                                        justifyContent="center"
                                        style={{ marginTop: '50px' }}
                                    >   
                                        <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                            <img src={errorImage} alt="error" width={"200px"} />
                                        </Box>
                                        <Typography color="secondary" variant="h3" style={{
                                            textAlign: "center"
                                        }}><MdOutlineError size={18} style={{
                                            margin: "20px 0 0 0",
                                        }} /> Cannot fetch pool details at the moment. Please try later.</Typography>
                                    </Grid>
                                </Grid>
                            :
                                <Grid
                                    container
                                    direction="row"
                                    className={classes.root}
                                    spacing={4}
                                >
                                    <Grid
                                        item
                                        lg={2}
                                        md={12}
                                        xs={12}
                                        sm={12}
                                    >
                                        <DynamicVerticalMenu titles={titles} />
                                    </Grid>
                                    <Grid 
                                        item
                                        lg={10}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                    >
                                        <Grid 
                                            container 
                                            direction={ isActive ? "column-reverse" : "row"}
                                            style={{
                                                display: "flex",
                                            }}
                                            spacing={4}
                                        >
                                            <Grid
                                                item
                                                lg={8}
                                                md={12}
                                                sm={12}
                                                xs={12}
                                            >
                                                <Detail poolData={poolData} poolContent={poolContent} />
                                            </Grid>
                                            <Grid
                                                item
                                                lg={4}
                                                md={12}
                                                sm={12}
                                                xs={12}
                                            >
                                                <Grid container xs={12} direction="column">
                                                    <Grid item>
                                                        <PoolDetailCard poolData={poolData} getWhitelisted={getWhitelisted} whitelistedCompleted={whitelistedCompleted} failed={failed} investBtn={investBtn} isExternalProject={isExternalProject} openWhitelistExternalModal={() => toggleWhitelistExternalModal(true)} showCountryModal={ () => setShowCountryModal(true) } code={ code } />
                                                    </Grid>
                                                    <PartnerStakeWrapper poolData={poolData} />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                    }
                    {
                        openWhitelistExternalModal && (
                            <WhitelistExternalModal open={openWhitelistExternalModal} handleClose={() => toggleWhitelistExternalModal(false)} code={code} poolId={poolData?.id} />
                        )
                    }
                    {
                        showCountryModal && (
                        <CountryModal open={showCountryModal} handleClose={() => setShowCountryModal(false)} refId={getProfileData?.id} email={getProfileData?.email} />
                        )
                    }
                </Container>
            }
            <Footer /> 
        </>
    )
}

export default PoolDetail;